// extracted by mini-css-extract-plugin
module.exports = {"row":"Page_row__35DtZ","col-sidebar":"Page_col-sidebar__hWIdf","col":"Page_col__3X_e3"};